import React, { Component, PropTypes } from 'react';
import { Dialog, FlatButton } from 'material-ui';
import { List as iList } from 'immutable';
import VertDropDown from '../tc-ui/vert-dropdown';
import NewCard from '../tc-ui/new-card';
import Icon from '../tc-ui/icon';
import { editLocationField } from '../../stores/profile/location/location-actions';
import { path, ifElse, T, call } from 'ramda';

import languagesObj from '../../localization/languages.json';
const languageSettings = languagesObj['en-US'];

class Contacts extends Component {

  constructor() {
    super();
    this.state = {
      showResults: false,
      removeContactDialog: false,
      copyContactsDialog: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.routeName !== nextProps.routeName) this.setState({ showResults: false });
  }

  getListElementStyle(width, height, otherCss) {
    return Object.assign({
      display: 'inline-block',
      fontSize: '14px',
      fontWeight: '400',
      color: 'rgb(54%, 54%, 54%)',
      lineHeight: '21px',
      overflow: 'auto',
      clear: 'both',
      paddingRight: '16px',
      height: height || 'auto',
      verticalAlign: 'top',
      width,
    }, otherCss || {});
  }

  getHeaderStyle(width) {
    return {
      display: 'inline-block',
      fontSize: '14px',
      fontWeight: '600',
      color: 'rgb(54%, 54%, 54%)',
      marginRight: '16px',
      width,
    };
  }

  _addClass = (e) => {
    e.preventDefault();
    this.setState({
      showResults: !this.state.showResults,
    });
  };

  _dialogDismissed = () => {
    this.setState({
      errorDeletingContact: undefined,
    });
  };

  _removeContact = (index) => {
    // dialog, then delete
    const contactType = this.props.contacts[index].type;
    const contacts = this.props.contacts.filter((contact, contactIndex) => {
      if (contactIndex !== index) return true;
      return false;
    });
    const neededTypes = this._getDefaultContactTypes(contacts, this.props.routeName === 'profile');
    if (neededTypes.indexOf(contactType) !== -1) {
      this.setState({
        errorDeletingContact: {
          contactIndex: index,
          contactType: contactType.toLowerCase(),
        },
      });
      this._showDialog('removeContactDialog');
    } else {
      this.props._saveField({
        updateField: 'contacts',
        updateBody: contacts,
      });
    }
  };

  _editErrorContact = (index) => {
    this._editContact(index);
    this._dismissDialog('removeContactDialog');
  };

  _editContact = (index) => {
    this.props.editField('contacts', { type: 'contacts', index });
  };

  _dismissDialog = (dialog) => {
    this._dialogDismissed();
    this.setState({ [dialog]: false });
  };

  _showDialog = (dialog) => {
    this.setState({ [dialog]: true });
  };

  createContactList(contact, index, contacts) {
    const name = (() => {
      if (contact.firstName) return `${contact.firstName} ${contact.lastName}`;
      if (contact.first_name) return `${contact.first_name} ${contact.last_name}`;
      if (contact.name) return contact.name;
    })();
    const lastElement = (index === contacts.length - 1);
    const fax = contact.fax ? (
      <div
        style={{
          maxHeight: '32px',
          display: 'block',
          position: 'relative',
        }}
      >
        <Icon className="tc-icon-print" style={{ marginRight: '5px', lineHeight: '21px' }}/>
        <span
          style={{
            lineHeight: '21px',
            position: 'relative',
            display: 'inline-block',
            verticalAlign: 'text-bottom',
          }}
        >
          {contact.fax}
        </span>
      </div>
      ) : (
      <div
        style={{
          maxHeight: '32px',
          display: 'block',
          position: 'relative',
        }}
      >
        <span
          style={{
            lineHeight: '21px',
            position: 'relative',
            display: 'inline-block',
            verticalAlign: 'text-bottom',
          }}
        />
      </div>
    );

    const options = [{
      text: 'Edit',
      action: this._editContact.bind(this, index),
    }, {
      text: 'Delete',
      action: this._removeContact.bind(this, index),
    }];

    return (
      <div
        key={index}
        ref={`contactItem${index}`}
        className="contact-info"
        style={{
          display: 'inline-block',
          lineHeight: '21px',
          width: '100%',
          minHeight: '80px',
          maxHeight: '68px',
          borderBottom: lastElement ? null : '2px solid #f5f5f5', padding: '16px',
        }}
      >
        <div style={this.getListElementStyle('26%', '64px')}>{contact.type}</div>
        <div style={this.getListElementStyle('40%')}>
            <div>{name}</div>
            <div>{contact.email}</div>
        </div>
        <div style={this.getListElementStyle('30%')}>
            <div style={{
              maxHeight: '32px',
              display: 'block',
              position: 'relative',
            }}
            >
              <Icon className="tc-icon-local-phone" style={{
                marginRight: '8px',
                lineHeight: '21px',
                float: 'left',
                overflow: 'hidden',
                clear: 'both',
                fontSize: '20px',
              }}
              />
              <span style={{
                lineHeight: '21px',
                position: 'relative',
                display: 'inline-block',
              }}
              >{contact.phone}</span>
            </div>
            {fax}
        </div>
        {this.props.isEditable ? (
          <VertDropDown
            style={this.getListElementStyle('4%', 'auto', { overflow: undefined, verticalAlign: 'middle' })}
            componentClassName="profile-contact-more-vert"
            options={options}
          />
        ) : null}
      </div>
    );
  }

  _addContact = (type) => {
    this.props.editField('contacts', {
      type: 'contacts',
      newContact: true,
      contactType: type,
      initialValue: this.props.contacts.concat({
        type,
      }),
      index: this.props.contacts.length,
    });
  };

  _getDefaultContactTypes = (optionalContacts, isOnProfile) => {
    const contacts = optionalContacts || this.props.contacts;
    let defaults = ['Billing', 'Sales', 'Reservation'];
    if (isOnProfile) defaults.push('Administrator');
    defaults = defaults.filter((type) => {
      // checks if exists
      return contacts && !contacts.some(contact => type === contact.type);
    });
    if (!defaults.length) return [''];
    return defaults;
  };

  sortContactsByName = (contactOne, contactTwo) => {
    if ((contactOne.type && contactTwo.type) && contactOne.type.toLowerCase() > contactTwo.type.toLowerCase()) return 1;
    if ((contactOne.type && contactTwo.type) && contactOne.type.toLowerCase() < contactTwo.type.toLowerCase()) return -1;
    if ((contactOne.first_name && contactTwo.first_name) && contactOne.first_name.toLowerCase() > contactTwo.first_name.toLowerCase()) return 1;
    if ((contactOne.first_name && contactTwo.first_name) && contactOne.first_name.toLowerCase() < contactTwo.first_name.toLowerCase()) return -1;
    if ((contactOne.name && contactTwo.name) && contactOne.name.toLowerCase() > contactTwo.name.toLowerCase()) return 1;
    if ((contactOne.name && contactTwo.name) && contactOne.name.toLowerCase() < contactTwo.name.toLowerCase()) return -1;
    return 0;
  };

  _copyContacts = () => {
    const { dispatch, params } = this.props;
    const { locationId: id } = params;
    dispatch(editLocationField({
      updateField: 'contacts',
      updateBody: this.props.user.company.contacts,
      id,
    }));
    this._dismissDialog('copyContactsDialog');
  };

  render() {
    const { isEditable, routeName, className, profileToShow, isViewingOwnProfile } = this.props;
    const shouldShowContactInfo = call(ifElse(
      path(['profileToShow', 'connectionInfo']),
        path(['profileToShow', 'connectionInfo', 'shouldShowContactInfo']),
      T
    ), this.props);
    if (!shouldShowContactInfo && !isViewingOwnProfile || isViewingOwnProfile && profileToShow.viewingAs === 'unconnected') return <div/>;

    let copyFromCompanyProfileNode = (
              <div style={{ display: 'inline-block', marginTop: '12px', marginLeft: '8px', fontSize: '16px', float: 'right' }} className="profile-edit-icon-container" onClick={this._showDialog.bind(this, 'copyContactsDialog')}>
                <Icon className="tc-icon-copy profile-edit-icon"/>
                Copy from Company Profile
              </div>);
    const contactsList = (() => {
      if (this.props.contacts && this.props.contacts.length) {
        if (this.props.contacts.length > 1 || routeName === 'profile') copyFromCompanyProfileNode = null;
        return this.props.contacts
                .sort(this.sortContactsByName)
                .map((contact, index, contacts) => this.createContactList(contact, index, contacts));
      }
      return iList();
    })();
    let gradient;


    const label = contactsList.length > 4 && !this.state.showResults ? languageSettings.company.more : null;
    const more = contactsList.length > 4 && !this.state.showResults ? label : null;

    if (contactsList.length > 4 && !this.state.showResults) gradient = <div style={{ bottom: '-8px', width: '100%' }} className="cardGradient" />;

    let contactsListStyle;
    if (contactsList.length > 4 && !this.state.showResults) contactsListStyle = { maxHeight: '340px' };

    let addContactDiv;
    if (isEditable) {
      addContactDiv = this._getDefaultContactTypes(null, routeName === 'profile').map((contactType, index) => {
        return (
          <div className="add-contacts" style={{ cursor: 'pointer', lineHeight: '21px', height: '68px', borderBottom: '2px solid #f5f5f5', padding: '0px 16px' }} onClick={this._addContact.bind(this, contactType)} key={index}>
            <div className="profile-image-add-container"style={{ display: 'inline-block', verticalAlign: 'middle', lineHeight: '68px' }}>
              <div className="profile-image profile-image-add">
                <div className="profile-image-letter"> <Icon className="tc-icon-add"/> </div>
              </div>
            </div>
            <div style={{ display: 'inline-block', marginLeft: '16px', height: '68px', verticalAlign: 'middle' }}>
              <h4 className="add-contacts-header" style={{ fontWeight: '300', paddingTop: '16px', lineHeight: '38px', verticalAlign: 'middle' }}> Add {contactType} Contact</h4>
            </div>
          </div>
        );
      });
    }

    const overflow = contactsList && contactsList.length > 4 && !this.state.showResults ? 'hidden' : 'visible';
    let dialogActions;
    let errorDeletingContactType;
    if (this.state.errorDeletingContact) {
      errorDeletingContactType = this.state.errorDeletingContact.contactType;
      dialogActions = [
        <FlatButton
          label="Edit"
          onTouchTap={this._editErrorContact.bind(this, this.state.errorDeletingContact.contactIndex)}
          secondary
          disableTouchRipple
        />,
        <FlatButton
          label="OK"
          onTouchTap={this._dismissDialog.bind(this, 'removeContactDialog')}
          primary
          disableTouchRipple
        />,
      ];
    }
    const dialogActionsforCopy = [
      <FlatButton
        label="Cancel"
        onTouchTap={this._dismissDialog.bind(this, 'copyContactsDialog')}
        secondary
        disableTouchRipple
      />,
      <FlatButton
        label="OK"
        onTouchTap={this._copyContacts}
        primary
        disableTouchRipple
      />,
    ];
    return (
      <div className={className} id="contactsNode">
        <Dialog
          className="form-dialog"
          ref="removeContact"
          title={'Contact Cannot Be Removed'}
          actions={dialogActions}
          open={this.state.removeContactDialog}
          onRequestClose={this._dismissDialog.bind(this, 'removeContactDialog')}
        >
          {`You must have at least one ${errorDeletingContactType} contact.`}
        </Dialog>
        <Dialog
          className="form-dialog"
          ref="copyContacts"
          title="Copy Contacts From Company Profile"
          actions={dialogActionsforCopy}
          open={this.state.copyContactsDialog}
          onRequestClose={this._dismissDialog.bind(this, 'copyContactsDialog')}
        >
          {'All existing contacts here will be overwritten. Are you sure you want to copy over all contacts from your company profile?'}
        </Dialog>
        <NewCard
          contentStyle={{ padding: '0px', overflow }}
          className="profile-card"
        >
          <div>
            <div style={{
              height: '48px',
              fontSize: '20px',
              fontWeight: '500',
              color: 'rgba(0, 0, 0, 0.87)' }} className="tc-card-header-title tc-new-card-header-title"
            >
              Contacts
            </div>
            {copyFromCompanyProfileNode}
          </div>
          <div style={contactsListStyle} ref="contactList">
            {addContactDiv}
            {contactsList}
            <div style={{ clear: 'both' }}></div>
            {gradient}
            <a href="#" style={{
              position: 'absolute',
              bottom: '12px',
              right: '8px',
              display: 'inline-block',
            }} className="load-more" onClick={this._addClass}
            > {more} </a>
          </div>
         </NewCard>
      </div>
    );
  }
}

Contacts.propTypes = {
  routeName: PropTypes.string,
  dispatch: PropTypes.func,
  params: PropTypes.object,
  user: PropTypes.object,
  profileToShow: PropTypes.object,
  isEditable: PropTypes.bool,
  className: PropTypes.string,
  contacts: PropTypes.array,
  editField: PropTypes.func,
  _saveField: PropTypes.func,
  isViewingOwnProfile: PropTypes.bool,
};

export default Contacts;



// WEBPACK FOOTER //
// ./src/app/components/profile/company-contact.jsx